__turbopack_context__.v({
  "button_left_aligned": "styles-module-scss-module__Of2oJG__button_left_aligned",
  "jumbotron_banner": "styles-module-scss-module__Of2oJG__jumbotron_banner",
  "jumbotron_banner_bar": "styles-module-scss-module__Of2oJG__jumbotron_banner_bar",
  "jumbotron_banner_buttons": "styles-module-scss-module__Of2oJG__jumbotron_banner_buttons",
  "jumbotron_banner_card": "styles-module-scss-module__Of2oJG__jumbotron_banner_card",
  "jumbotron_banner_centered": "styles-module-scss-module__Of2oJG__jumbotron_banner_centered",
  "jumbotron_banner_content": "styles-module-scss-module__Of2oJG__jumbotron_banner_content",
  "jumbotron_banner_cta": "styles-module-scss-module__Of2oJG__jumbotron_banner_cta",
  "jumbotron_banner_image": "styles-module-scss-module__Of2oJG__jumbotron_banner_image",
  "jumbotron_banner_left_centered": "styles-module-scss-module__Of2oJG__jumbotron_banner_left_centered",
  "jumbotron_banner_wrapper": "styles-module-scss-module__Of2oJG__jumbotron_banner_wrapper",
  "jumbotron_simple": "styles-module-scss-module__Of2oJG__jumbotron_simple",
});
